import { ADD_PRODUCT_CURRENCY } from "../../types/ProductCurrencyType";
import axios from "axios";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const addProductCurrencyAction = (data) => {
	return {
		type: ADD_PRODUCT_CURRENCY,
		payload: data,
	};
};

export const addProductCurrency = (values) => {
	return async (dispatch) => {
		try {
			const payload = {
				...values,
			};
			// Format date if present - check if it's a dayjs object or can be converted
			if (values.effective_from_date) {
				if (dayjs.isDayjs(values.effective_from_date)) {
					payload.effective_from_date = values.effective_from_date.format('YYYY-MM-DD');
				} else if (values.effective_from_date.format && typeof values.effective_from_date.format === 'function') {
					payload.effective_from_date = values.effective_from_date.format('YYYY-MM-DD');
				} else {
					// If it's already a string or other format, try to convert it
					payload.effective_from_date = dayjs(values.effective_from_date).format('YYYY-MM-DD');
				}
			}
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `product-currency/`,
				data: payload,
			});
			//dispatching data
			dispatch(addProductCurrencyAction(data));
			toast.success("product Currency Added");
			return {
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding currency try again");
			console.log(error?.message || error || "An error occurred");
			return {
				message: "error",
			};
		}
	};
};
